import axios from "axios";
import { message as AntdAlert } from "antd";
import { put } from "redux-saga/effects";
import * as actions from "../actions";
import { baseURL } from "../../../../globalUtils/axiosConfig";
import errorHandler from "../../../../components/unauthorizeHandler";

export function* handleFetchDepartments({ data }) {
  const { search, ...rest } = data;
  Object.keys(search).forEach((key) => {
    if (search[key]?.length < 1 || search[key] === null) delete search[key];
  });

  try {
    // const response = yield axios.get(`${baseURL}/api/v1/activity_types`, {
    const response = yield axios.get(`${baseURL}/department`, {
      params: { ...rest, ...(Object.keys(search).length > 0 && { ...search }) },
    });
    if (response.status === 200) {
      yield put(actions.fetchDepartmentsSuccess(response.data.departments));
    } else {
      errorHandler(response.data);
    }
  } catch (error) {
    yield put(actions.fetchDepartmentsError());
    AntdAlert.error("Something went wrong!");
    console.log(error);
  }
}

export function* handleUpdateDepartment({ data }) {
  const { name, id } = data;
  try {
    const response = yield axios.patch(`${baseURL}/department/${id}`, {
      name,
    });
    if (response.status === 200) {
      AntdAlert.success("Department updated successfully");
      yield put(actions.updateDepartmentSuccess(data));
    } else {
      AntdAlert.error("Something went wrong!");
      yield put(actions.updateDepartmentError(response.data));
      errorHandler(response.data);
    }
  } catch ({ response }) {
    yield put(actions.updateDepartmentError(response.data));
    AntdAlert.error("Something went wrong!");
    console.log(response);
  }
}

export function* handleDeleteDepartments({ data }) {
  const { id } = data;
  try {
    const response = yield axios.delete(`${baseURL}/department/${id}`);

    if (response.status === 200) {
      AntdAlert.success("Department deleted successfully");
      yield put(actions.deleteDepartmentSuccess(id));
    } else {
      AntdAlert.error("Something went wrong!");
      yield put(actions.deleteDepartmentError(response.data));
      errorHandler(response.data);
    }
  } catch ({ response }) {
    yield put(actions.deleteDepartmentError(response.data));
    AntdAlert.error(response?.data?.message || "Something went wrong!");
    console.log(response);
  }
}

export function* handleCreateDepartment({ data }) {
  try {
    const response = yield axios.post(`${baseURL}/department`, {
      name: data.name,
    });

    console.log(response);
    if (response.status === 201) {
      AntdAlert.success("Department created successfully");
      yield put(actions.createDepartmentSuccess(response.data));
    } else {
      AntdAlert.error("Something went wrong!");
      yield put(actions.createDepartmentError());
      errorHandler(response.data);
    }
  } catch ({ response }) {
    yield put(actions.createDepartmentError(response.data));
    AntdAlert.error("Something went wrong!");
    console.log(response);
  }
}
